"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Portal_native_exports = {};
__export(Portal_native_exports, {
  Portal: () => Portal,
  PortalHost: () => PortalHost
});
module.exports = __toCommonJS(Portal_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_OneNativePortalViewNativeComponent = __toESM(require("../specs/OneNativePortalViewNativeComponent"), 1);
var import_OneNativePortalHostViewNativeComponent = __toESM(require("../specs/OneNativePortalHostViewNativeComponent"), 1);
function Portal(param) {
  var { hostName = "", name = "", ...props } = param;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativePortalViewNativeComponent.default, {
    ...props,
    hostName,
    name
  });
}
function PortalHost(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativePortalHostViewNativeComponent.default, {
    ...props
  });
}
//# sourceMappingURL=Portal.native.js.map
